import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { API_BASE_URL } from './bistrack-client';


@Injectable({
  providedIn: 'root'
})
export class BistrackClientExtension {
  private httpClient: HttpClient;
  private baseURL: string;
  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.httpClient = http;
    this.baseURL = baseUrl ? baseUrl : "";
  }

  downloadFile(fileName: string): Observable<Blob> {
    let url_ = this.baseURL + "/api/Debug/Log/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",			
            headers: new HttpHeaders({
            })
        };

    return this.httpClient.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDownloadFile(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDownloadFile(<any>response_);
        } catch (e) {
          return <Observable<Blob>><any>_observableThrow(e);
        }
      } else
        return <Observable<Blob>><any>_observableThrow(response_);
    }));
  }

  protected processDownloadFile(response: HttpResponseBase): Observable<Blob> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return _observableOf<Blob>(<any>responseBlob);
    }
    else if (status === 404) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return throwException("A server error occurred.", status, _responseText, _headers);
      }));
    }
    return _observableOf<Blob>(<any>null);
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return null;
    
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next("");
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
} 